import { render, staticRenderFns } from "./SchoolLeaderboard.vue?vue&type=template&id=7e087d2f&scoped=true&"
import script from "./SchoolLeaderboard.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLeaderboard.vue?vue&type=style&index=0&id=7e087d2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e087d2f",
  null
  
)

export default component.exports